import qs from 'query-string';
import { RequestManagerNext } from '../requestManager/requestManagerNext';
export interface CustomFields {
  name: string;
}

export interface Item {
  productId: string;
  quantity: number;
  customFields?: CustomFields;
}

export interface ShippingAddress {
  name: string;
  street: string;
  houseNumber: string;
  zipCode: string;
  city: string;
  country: string;
  additionalInfo?: string;
}

export interface PrepareOrderBody {
  source?: string;
  campaign?: string;
  buyerEmail: string;
  paymentType?: string;
  externalSubscriptionId?: string;
  items: Item[];
  voucherCode?: string;
  shippingAddress: ShippingAddress;
}
interface ICheckSubscription {
  productId: string;
  customFields: any;
}
export const OrdersService = {
  prepareOrder: async (body: PrepareOrderBody): Promise<any> => {
    const queries = qs.stringify({
      campaign:
        window.sessionStorage.getItem('campaign') !== null
          ? window.sessionStorage.getItem('campaign')
          : undefined,
      source:
        window.sessionStorage.getItem('source') !== null
          ? window.sessionStorage.getItem('source')
          : undefined,
    });

    const { data } = await RequestManagerNext.post(
      `/api/order/createOrder${queries && `?${queries}`}`,
      body
    );
    return data;
  },
  captureOrder: async ({ id }: { id: string }): Promise<any> => {
    const { data } = await RequestManagerNext.post(
      `/api/order/captureOrder?id=${id}`,
      {}
    );
    return data;
  },
  cancelOrder: async ({ id }: { id: string }): Promise<any> => {
    const { data } = await RequestManagerNext.post(
      `/api/order/cancelOrder?id=${id}`,
      {}
    );
    return data;
  },
  getOrder: async ({ id }: { id: string }): Promise<any> => {
    const { data } = await RequestManagerNext.get(
      `/api/order/getOrder?id=${id}`
    );
    return data;
  },
  sendPostprocessingData: async ({
    id,
    body,
  }: {
    id: string;
    body: any;
  }): Promise<any> => {
    const { data } = await RequestManagerNext.post(
      `/api/order/postProcessing?id=${id}`,
      body
    );
    return data;
  },
  checkSubscription: async (body: ICheckSubscription): Promise<any> => {
    const { data } = await RequestManagerNext.post(
      `/api/order/subscriptionCheck`,
      body
    );
    return data;
  },
};
